module.exports = __webpack_public_path__ + "img/GAME_POND2.eeebe54a.jpg";